import React, { Fragment } from "react";
import Pagination from "assets/scripts/components/presentational/Pagination/Pagination";
import { defineMessages, FormattedDate, FormattedNumber, FormattedMessage } from "react-intl";
import DisclaimerId from "../DisclaimerId/DisclaimerId";
import AccountNumber from "assets/scripts/components/presentational/AccountNumber/AccountNumber";
import Table from "assets/scripts/components/presentational/Table/Table";
import styles from "./RouteTable.module.less";
import DateOfService from "assets/scripts/components/presentational/DateOfService/DateOfService";
const messages = defineMessages({
    creditor: {
        id: "dashboard.accountList.accountCard.routeTable.creditor",
        defaultMessage: "Creditor"
    },
    referenceNumber: {
        id: "dashboard.accountList.accountCard.routeTable.referenceNumber",
        defaultMessage: "Reference #"
    },
    accountNumber: {
        id: "dashboard.accountList.accountCard.routeTable.accountNumber",
        defaultMessage: "Account #"
    },
    balance: {
        id: "dashboard.accountList.accountCard.routeTable.balance",
        defaultMessage: "Balance"
    },
    decLastName: {
        id: "dashboard.accountList.accountCard.routeTable.decLastName",
        defaultMessage: "Decedent Last Name"
    },
    dateOfService: {
        id: "dashboard.accountList.accountCard.routeTable.dateOfService",
        defaultMessage: "Date of Service"
    },
    dateAdded: {
        id: "dashboard.accountList.accountCard.routeTable.dateAdded",
        defaultMessage: "Date Added To ServiceLink"
    }
});
function getColumns(props) {
    const columns = [];
    if (process.env.CLIENT == null || props.group.accounts.some(it => it.creditor != null)) {
        columns.push({
            header: messages.creditor,
            value: it => it.creditor,
            size: "m"
        });
    }
    columns.push({
        header: messages.referenceNumber,
        value: it => it.refNum,
        size: "s"
    }, {
        header: messages.accountNumber,
        value: account => (<Fragment>
					<AccountNumber value={account.acctNum}/>
					{props.showDisclaimerIds && (<DisclaimerId value={account.disclaimer.map(it => props.disclaimerIdMap[it])}/>)}
				</Fragment>),
        size: "s"
    });
    if (props.group.open) {
        columns.push({
            header: messages.balance,
            value: account => {
                if (account.accountClosed) {
                    return (<span className={styles.closed}>
							<span className="u-isVisuallyHidden">Not applicable </span>
							<FormattedMessage id="dashboard.accountList.accountCard.routeTable.accountClosed" defaultMessage="Account has been closed with DCM Services"/>
						</span>);
                }
                return (<FormattedNumber value={account.balance} style="currency" currency="USD"/>);
            },
            size: "xs"
        });
    }
    if (props.group.primary.deceased && props.showDecLastName) {
        columns.push({
            header: messages.decLastName,
            value: it => it.lastName,
            size: "m"
        });
    }
    if (props.expanded) {
        columns.push({
            header: messages.dateOfService,
            value: account => (<DateOfService account={account}/>),
            size: "s"
        }, {
            header: messages.dateAdded,
            value: ({ createTimetampUtc }) => (<FormattedDate value={createTimetampUtc}/>),
            size: "m"
        });
    }
    return columns;
}
const RouteTable = (props) => {
    const columns = getColumns(props);
    const accountsPerPage = props.accountsPerPage || 5;
    return (<Pagination items={props.group.accounts} itemsPerPage={accountsPerPage}>
			{({ page, renderPager, pageIndex }) => (<div>
					<Table items={page} columns={columns} srLabel={"Account"} srLabelPlural={"Accounts"} pageIndex={pageIndex} itemsPerPage={accountsPerPage} getKey={it => it.id}/>
					{renderPager("Account")}
				</div>)}
		</Pagination>);
};
export default RouteTable;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/Dashboard/AccountList/AccountCard/RouteTable/RouteTable.tsx